import { IApplicationState } from '../../types/redux';

export const selectModelVersion = (state: IApplicationState) => {
  return state.newbuildingRecommendations.modelVersion;
};
